<template>
	<div class="evaluatorlist-parentdiv">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div
			class="headtext mt-3 d-flex align-items-center justify-content-between"
		>
			<div class="heading">
				<span>Evaluator List</span>
			</div>

			<b-button
				class="addbtn"
				v-if="roles.includes('PUSH_EVALUATOR')"
				@click="addevalcontainer = true"
			>
				<img src="../../assets/plusicon.svg" alt="" class="mr-2 mb-1" />
				<span class="">Add Evaluator</span>
			</b-button>
		</div>
		<div
			id="filtermodal"
			v-if="filtermodalshow"
			ref="filterdropdown"
			class="eval-filter-modal"
		>
			<div class="qb-fm-heading p-2">
				<div class="xMarkCancel pointer" @click="hideFilterFunction">
					<img src="../../assets/xmark.svg" alt="" />
				</div>
				Filter By
			</div>
			<div class="p-3">
				<div class="topDiv mt-3" @click.stop="">
					<label class="fieldsetStyle"
						>Skills&nbsp;<span class="asterik">*</span></label
					>
					<b-form-tags
						class="inputField"
						placeholder="Enter Skills"
						v-model.trim="filter.skills"
						remove-on-delete
					></b-form-tags>
				</div>

				<div class="topDiv mt-3" @click.stop="">
					<label class="fieldsetStyle"
						>Area Of Expertise&nbsp;<span class="asterik">*</span></label
					>
					<b-form-tags
						class="inputField"
						placeholder="Enter Area of Expertise"
						v-model.trim="filter.areaOfExpertise"
						remove-on-delete
					></b-form-tags>
				</div>

				<div class="d-flex align-items-end justify-content-between mt-3">
					<span
						class="qb-clear mt-2"
						:class="
							filter.skills.length == 0 && filter.areaOfExpertise.length == 0
								? filtercount == 0
									? 'disabled-text'
									: 'pointer'
								: 'pointer'
						"
						@click="
							filter.skills.length == 0 && filter.areaOfExpertise.length == 0
								? filtercount == 0
									? ''
									: clearfilter()
								: filtercount == 0
								? clearfilter()
								: clearfilter()
						"
						>Clear Filter</span
					>
					<b-button
						:disabled="
							filter.skills.length == 0 && filter.areaOfExpertise.length == 0
						"
						class="addbtn pl-2 pr-2 pt-1 pb-1"
						@click="filterapply()"
					>
						<span class="">Apply</span>
					</b-button>
				</div>
			</div>
		</div>
		<div class="eval-main-table mt-2">
			<div class="eval-table-head m-1">
				<div class="eval-name-col pl-3">
					Name
					<template v-if="sortColumn == 'name'">
						<img
							@click="sort('name')"
							v-if="sorting == true"
							src="../../assets/icons/share/ascending.svg"
							alt=""
							class="pointer ml-1"
						/>
						<img
							v-else
							@click="sort('name')"
							src="../../assets/icons/share/descending.svg"
							alt=""
							class="pointer ml-1"
						/>
					</template>
					<img
						v-else
						@click="sort('name')"
						src="../../assets/icons/share/nosort.svg"
						alt=""
						class="pointer ml-1"
					/>
				</div>
				<div class="eval-email-col">
					Email ID
					<template v-if="sortColumn == 'email'">
						<img
							@click="sort('email')"
							v-if="sorting == true"
							src="../../assets/icons/share/ascending.svg"
							alt=""
							class="pointer ml-1"
						/>
						<img
							v-else
							@click="sort('email')"
							src="../../assets/icons/share/descending.svg"
							alt=""
							class="pointer ml-1"
						/>
					</template>
					<img
						v-else
						@click="sort('email')"
						src="../../assets/icons/share/nosort.svg"
						alt=""
						class="pointer ml-1"
					/>
				</div>
				<div class="eval-cont-col">Contact Number</div>
				<div class="eval-exp-col">Area of Expertise</div>
				<div class="eval-skill-col">Skills</div>
				<div class="eval-filter-col d-flex position-relative">
					<img
						class="pointer"
						@click="modalpop()"
						v-b-popover.hover.top="'Filter'"
						src="../../assets/whitefilter.svg"
						alt=""
						v-closable="{
							exclude: ['filterdropdown', 'skl', 'exp'],
							handler: 'hideFilterFunction',
						}"
					/>
					<div
						class="qb-filter-count position-absolute p-0 d-flex align-items-center justify-content-center"
						v-if="filtercount != 0"
						style="left: 18px;top: -10px;"
					>
						{{ filtercount }}
					</div>
				</div>
			</div>
			<div class="eval-table-body p-1" id="eval-scroll-table">
				<template v-if="total === 0">
					<div
						v-if="searchTopicTestState == '' && total == 0"
						class="d-flex flex-column align-items-center justify-content-center h-100"
					>
						<div>
							<img src="../../assets/searchnotfound.svg" alt="" />
						</div>
						<div>
							<span class="searchnotfound">No data found.</span>
						</div>
					</div>

					<div
						v-if="
							searchTopicTestState != '' && searchTopicTestState != 'Loader'
						"
						class="d-flex flex-column align-items-center justify-content-center h-100"
					>
						<div>
							<img src="../../assets/searchnotfound.svg" alt="" />
						</div>
						<div class="text-center">
							<span class="searchnotfound"
								>No matching results for
								<span class="searchtext text-break">
									"{{ searchTopicTestState }}"
								</span>
								.</span
							>
						</div>
					</div>
				</template>
				<template v-else>
					<div
						class="eval-table-row"
						v-for="(input, index) in evaluatorlist"
						:key="index"
					>
						<div class="eval-name-col pr-3 text-truncate">
							<div class="evalbluecolorDynamic"></div>
							<div class="pl-3 text-truncate">
								<span
									v-b-popover.hover="input.name"
									style="max-width: 100%"
									class="d-inline-block text-truncate"
									>{{ input.name }}</span
								>
							</div>
						</div>
						<div class="eval-email-col pr-3 text-truncate">
							<span>{{ input.email }}</span>
						</div>
						<div class="eval-cont-col">
							{{ input.phoneNumber }}
						</div>
						<div class="eval-exp-col pr-3 text-truncate">
							<span :id="'jo' + input.evaluatorID">
								{{ input.areaOfExpertise | fnName }}</span
							>
							<span>
								<b-popover
									:target="'jo' + input.evaluatorID"
									triggers="hover"
									placement="top"
								>
									<span v-for="jo in input.areaOfExpertise" :key="jo.id"
										>{{ jo.name
										}}<span v-if="input.areaOfExpertise.length > 1">,</span>
									</span>
								</b-popover>
							</span>
						</div>
						<div class="eval-skill-col pr-3 text-truncate">
							<span :id="'tp' + input.evaluatorID">
								{{ input.skills | fnName }}</span
							>
							<span>
								<b-popover
									:target="'tp' + input.evaluatorID"
									triggers="hover"
									placement="top"
								>
									<span v-for="(me, i) in input.skills" :key="me.id"
										>{{ me.name
										}}<span v-if="i != input.skills.length - 1">,</span>
									</span>
								</b-popover>
							</span>
						</div>
						<div class="eval-filter-col">
							<div class="d-flex">
								<div v-if="roles.includes('PUT_EVALUATOR')">
									<img
										@click="gotoediteval(input)"
										v-b-popover.hover.top="'Edit'"
										src="../../assets/pencilicon.svg"
										alt=""
										class="mr-3 pointer"
									/>
								</div>
								<div v-if="roles.includes('DELETE_EVALUATOR')">
									<img
										class="pointer mr-1"
										v-b-popover.hover.top="'Delete'"
										src="../../assets/deleteicon.svg"
										alt=""
										@click="EvalDelete(input)"
									/>
								</div>
							</div>
						</div>
					</div>
				</template>
			</div>
			<div class="paginaTion d-flex justify-content-between align-items-center">
				<div class="d-flex">
					<span class="qb-gotopage-text p-1">Go to Page</span>
					<b-form-input
						type="text"
						class="qb-pagination-num mr-1"
						v-model.trim="goToPage"
						@keyup.enter="
							goToPage === null || goToPage == '' || iscontainsNumber
								? ''
								: goToPageNo(goToPage)
						"
					></b-form-input>
					<b-button
						:disabled="goToPage === null || goToPage == '' || iscontainsNumber"
						class="qb-pagination-addbtn"
						@click="goToPageNo(goToPage)"
					>
						<span><img src="../../assets/whiterightarrow.svg" alt=""/></span>
					</b-button>
				</div>
				<div class="pagination">
					<b-pagination
						v-model.number="currentPage"
						@input="goToPageNum()"
						:total-rows="total"
						:per-page="count"
						align="center"
						first-number
						last-number
					>
						<template #prev-text
							><span><img src="../../assets/leftvector.svg" alt="" /> </span
						></template>
						<template #next-text
							><span><img src="../../assets/rightarrow.svg" alt=""/></span
						></template>
					</b-pagination>
				</div>
				<div class="qb-gotopage-text mr-2">
					Results : <span v-if="pageStart > total">0</span
					><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
					<span class="pl-1"></span> of <span class="pr-1"></span>{{ total }}
				</div>
			</div>
		</div>

		<!-- *****************   Add Evaluator Container   ******************************* -->
		<Transition name="slide">
			<div class="addeval-half-container p-3" v-if="addevalcontainer">
				<div class="d-flex align-items-center justify-content-between">
					<div
						@click="addevalcontainer = false"
						class="position-absolute pointer swp-backArrow"
					>
						<img src="../../assets/backArrow.svg" alt="" />
					</div>
					<div class="swp-group-main-heading ml-3 mt-2">Add Evaluator</div>
					<div class="d-flex align-items-center">
						<div @click="addevalcontainer = false" class="pointer">
							<img
								v-b-popover.hover.top="'Close'"
								src="../../assets/roundClose.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<hr />
				<AddEvaluator @onAddEvaluator="handleAddEvaluator" />
			</div>
		</Transition>

		<!-- *****************  End  Add Evaluator Container ******************************* -->

		<!-- *****************   Edit Evaluator Container   ******************************* -->

		<Transition name="slide">
			<div class="addeval-half-container p-3" v-if="editevalcontainer">
				<div class="d-flex align-items-center justify-content-between">
					<div
						@click="editevalcontainer = false"
						class="position-absolute pointer swp-backArrow"
					>
						<img src="../../assets/backArrow.svg" alt="" />
					</div>
					<div class="swp-group-main-heading ml-3 mt-2">Edit Evaluator</div>
					<div class="d-flex align-items-center">
						<div @click="editevalcontainer = false" class="pointer">
							<img
								v-b-popover.hover.top="'Close'"
								src="../../assets/roundClose.svg"
								alt=""
							/>
						</div>
					</div>
				</div>
				<hr />
				<EditEvaluator
					:evaluatordata="evaluatordata"
					@onEditEvaluator="handleEditEvaluator"
				/>
			</div>
		</Transition>

		<!-- *****************  End  Edit Evaluator Container ******************************* -->

		<!-- start of new model having 5 screens-->

		<!--delete modal starts -->
		<b-modal id="modal-delete" centered hide-footer hide-header>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div class="xMarkCancel" @click="$bvModal.hide('modal-delete')">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span style="word-wrap: break-word"
					>Are you sure you want to delete the Evaluator "{{
						this.delEval.name
					}}" ?</span
				>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteEvaluator()">Delete</b-button>
			</div>
		</b-modal>
		<!--delete modal ends -->
	</div>
</template>

<script>
import { getEvaluatorAdmin, deleteEval } from "../../utils/apiFunctions";
import { mapGetters } from "vuex";

import toast from "../../views/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import AddEvaluator from "./AddEvaluator.vue";
import EditEvaluator from "./EditEvaluator.vue";
export default {
	mixins: [toast],
	data() {
		return {
			addevalcontainer: false,
			editevalcontainer: false,
			LoaderStatus: false,
			sorting: false,
			filtermodalshow: false,
			goToPage: null,
			totalPages: null,
			currentPage: 1,
			filtercount: 0,
			pageStart: "",
			pageEnd: "",
			total: "",
			prevpg: "",
			nxtpg: "",
			count: 50,
			sortColumn: "createdAt",
			evaluatorlist: [],
			delEval: {},
			filter: {
				areaOfExpertise: [],
				skills: [],
			},
			storefilter: {
				areaOfExpertise: [],
				skills: [],
			},
			modelshow: true,
			evaluatordata: {},
		};
	},
	components: {
		Spinner,
		AddEvaluator,
		EditEvaluator,
	},
	created() {
		this.getEvalList();
	},
	watch: {
		searchTopicTestState(oldValue, newValue) {
			if (oldValue != newValue) {
				this.getEvalList();
			}
		},
	},
	computed: {
		...mapGetters("searchVUEX", {
			searchTopicTestState: "getSearchTopicTest",
		}),
		// To check if it does not contain an alphabet or zero
		iscontainsNumber() {
			return !/^[1-9]\d*$/.test(this.goToPage);
		},
		...mapGetters(["roles"]),
	},
	filters: {
		fnName: function(value) {
			let sliced;
			if (value.length != 0) {
				sliced = value.slice(0);
			}
			let arr = [];
			for (let j of sliced) {
				arr.push(j.name);
			}

			if (arr.length > 3) {
				let arrsliced = arr.slice(0, 3) + "...";
				return arrsliced;
			} else {
				let arrsliced1 = arr.slice(0, 3) + "";
				return arrsliced1;
			}
		},
	},

	methods: {
		hideFilterFunction() {
			this.filtermodalshow = false;
		},
		// close the add container and update the data on screen
		handleAddEvaluator() {
			this.addevalcontainer = false;
			this.getEvalList();
		},
		// close the edit container and update the data on screen
		handleEditEvaluator() {
			this.editevalcontainer = false;
			this.getEvalList();
		},
		async getEvalList() {
			this.LoaderStatus = true;
			try {
				let payload = {
					tag: "0",
					page: this.currentPage - 1,
					count: this.count,
					sortBy: {
						column: this.sortColumn,
						order: this.sorting,
					},
					filters: {
						expertiseName: this.filter.areaOfExpertise,
						skillName: this.filter.skills,
					},
					searchQuery: this.searchTopicTestState,
				};
				const res = await getEvaluatorAdmin(payload);
				if (res.status == 200) {
					this.evaluatorlist = res.data.data.data;
					this.LoaderStatus = false;
					this.nxtpg = res.data.data.nextPage;
					this.prevpg = res.data.data.prevPage;
					this.pageStart = res.data.data.pageStart;
					this.pageEnd = res.data.data.pageEnd;
					this.total = res.data.data.total;
					this.totalPages = Math.ceil(
						parseInt(this.total) / parseInt(this.count)
					);
					const element = document.getElementById("eval-scroll-table");
					element.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		sort(data) {
			this.sortColumn = data;
			this.sorting = !this.sorting;
			this.getEvalList();
		},
		// The pagination buttons functionality allow you to move backward and forward through the page
		goToPageNo(index) {
			this.currentPage = Math.min(Math.max(1, index), this.totalPages);
			this.goToPage = null;
			this.getEvalList();
		},
		goToPageNum() {
			this.getEvalList();
		},
		modalpop() {
			this.filter = { ...this.storefilter };
			this.filtermodalshow = !this.filtermodalshow;
		},
		EvalDelete(data) {
			this.$bvModal.show("modal-delete");
			this.delEval = data;
		},
		gotonewmodel() {
			this.$bvModal.show("modal-del");
		},

		// Delete Evaluator API
		async deleteEvaluator() {
			try {
				const res = await deleteEval(this.delEval.evaluatorID);
				if (res.status == 200) {
					this.successToast("Evaluator deleted successfully");
					this.$bvModal.hide("modal-delete");
					this.getEvalList();
				} else {
					this.errorToast(res.data.data.Detail);
					this.$bvModal.hide("modal-delete");
				}
			} catch (error) {
				this.$bvModal.hide("modal-delete");
				this.errorToast(error.response.data.data.Details);
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		gotoediteval(data) {
			this.editevalcontainer = true;
			this.evaluatordata = { ...data };
		},

		filterapply() {
			this.storefilter = { ...this.filter };
			this.currentPage = 1;
			this.filtercount = 0;
			if (this.filter.skills.length != 0) {
				this.filtercount++;
			}
			if (this.filter.areaOfExpertise.length != 0) {
				this.filtercount++;
			}
			this.getEvalList();
			this.filtermodalshow = false;
		},
		clearfilter() {
			this.filter = {
				areaOfExpertise: [],
				skills: [],
			};
			this.storefilter = {
				areaOfExpertise: [],
				skills: [],
			};
			this.currentPage = 1;
			if (this.filtercount != 0) {
				this.getEvalList();
				this.filtermodalshow = false;
			}
			this.filtercount = 0;
		},
	},
};
</script>

<style>
.evaltags .b-form-tags .b-form-tags-list .b-from-tags-field,
.b-form-tags .b-form-tags-list .b-form-tag {
	margin-top: 0.5rem;
}

.evaltags .form-control {
	border: 1px solid var(--input-border);
	border-radius: 3px !important;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	line-height: 18px;
	z-index: 5;
	background: var(--bg-inputfield);
}
.evaltags .badge {
	padding: 0.1em 1em;
	line-height: 2;
}

.evaltags .badge-secondary {
	color: #72737e;
	font-size: 12px;
	font-weight: 400;
	background-color: #e7e8f5;
}

.evaluatorlist-parentdiv {
	position: relative;

	height: calc(100vh - 70px);
	top: 70px;
	padding-left: 80px;
	overflow-x: hidden;
	padding-right: 15px;
}

.addeval-half-container {
	position: absolute;
	width: 700px;
	height: calc(100vh - 80px);
	right: 5px;
	top: 5px;
	z-index: 5;
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}

/* transition for sliding */
.slide-leave-active,
.slide-enter-active {
	transition: 0.5s;
}

.slide-enter {
	transform: translate(100%, 0);
}

.slide-leave-to {
	transform: translate(100%, 0);
}

/* eo transition */

/* eol new css  */

.twobtns {
	position: absolute;
	bottom: 10px;
	right: 20px;
}

.sharemailbtns .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
	color: #696969;
	background-color: #f4f4f4;
	border-color: #f4f4f4;

	width: 100%;
	text-align: start;
}

.sharemailbtns .btn-secondary {
	color: #696969;
	background-color: #ffffff;
	border-color: #ffffff;
}

.cancelbtntext {
	font-weight: 600;
	font-size: 13px;
	color: #72738e;
}

.deliveredtext {
	font-weight: 500;
	font-size: 13px;
	color: #ad1927;
}

.activetext {
	font-weight: 500;
	font-size: 13px;
	color: #18a41d;
}

.normaltext {
	color: #696969;
	font-weight: 500;
	font-size: 13px;
}

.slectedcandidate-table-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 145px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 100%;
}

.grp-right-container {
	background: #ffffff;
	border-radius: 8px;
	height: calc(100vh - 155px);
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	width: 30%;
}

.eval-reports-table tbody {
	display: block;
	border-radius: 5px;
	overflow-x: auto;
	height: calc(100vh - 305px);
	margin-top: 5px;
	width: calc(100% + 30px);
}

.evalbluecolorDynamic {
	width: 4px;
	height: 41px;
	border-radius: 2px;
	position: absolute;
	left: 2px;
	top: 2px;
	background: #114c92;
}

.eval-reports-table thead tr {
	height: 45px;
	background: #72738e;
	border-radius: 3px;
	vertical-align: middle;
	display: table;
	width: 100%;
	table-layout: fixed;
}

.eval-reports-table thead th {
	font-weight: 500 !important;
	font-size: 14px;
	color: white;
}

.eval-reports-table thead th:last-child {
	padding-right: 15px;
}

.eval-reports-table tbody td {
	font-style: normal;
	font-weight: normal;
	font-size: 13px;
	color: #696969;
	overflow: hidden;
	text-overflow: ellipsis;
}

.eval-reports-table tbody td:first-child {
	position: relative;
}

.eval-reports-table tbody td:last-child {
	padding-right: 20px;
}

.eval-reports-table tbody tr {
	height: 60px;
	border: 0.5px solid #e5e5e5;
	box-sizing: border-box;
	background: #fcfcfc;
	box-shadow: 0px 4px 12px rgb(196 196 196 / 50%);
	margin: 10px 5px 8px 5px;
	width: calc(100% - 10px);
	display: table;
	border-radius: 3px;
	table-layout: fixed;
}

.shareppl-parentdiv {
	position: relative;
	height: calc(100vh - 90px);
	top: 80px;
	padding-left: 80px;
	overflow-x: hidden;
	padding-right: 15px;
}

.selected-table-cards:hover {
	background: #e7e8f5;
}

.shareview-details {
	background: #f5f5f5;
}

.shareview-details-bold {
	font-size: 12px;
	color: #696969;
	font-weight: var(--weight-LM);
}

.shareview-details-text {
	font-size: 12px;
	color: #696969;
	font-weight: var(--weight-R);
}

.shareview-details-email {
	font-size: 12px;
	color: #696969;
	font-weight: var(--weight-M);
}

.selectedCandidateContainer {
	height: 389px;
	overflow-y: auto;
}

.groupshare-formtag {
	border: none;
	padding: 0px;
}

.groupshare-seachinput {
	padding: 0.5rem 2rem !important;
}

.selectedColorbar {
	width: 4px;
	background: #4ef085;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 2.5px;
}

.deselectedColorbar {
	width: 4px;
	background: #ff4752;
	border-radius: 2px;
	position: absolute;
	height: 90%;
	top: 2.5px;
}

.configMoreData {
	color: #72738e;
	font-weight: var(--weight-LM);
}

.grouptable tbody {
	display: block;
	border-radius: 5px;
	overflow: auto;
	height: calc(100vh - 250px);
	margin-top: 5px;
	width: calc(100% - 5px);
}

.eval-filter-modal {
	position: absolute;
	width: 350px;
	top: 103px;
	right: 80px;
	background: #ffffff;
	border: 0.5px solid #adaaaa;
	box-shadow: 0px 6px 10px rgb(0 0 0 / 25%);
	border-radius: 5px;
	z-index: 6;
}

.qb-filter-count {
	width: 19px;
	background: #ff7e47;
	border-radius: 10px;
	height: 19px;
	font-weight: var(--weight-B);
	font-size: var(--size-10);
	padding-top: 2px;
	padding-left: 8px;
}

.modelheading {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 11px;
}

.step2icon {
	display: flex;
	justify-content: center;
	align-items: center;
}

.nexttbtn {
	margin-left: 680px;
	margin-right: auto;
}

.step4class {
	display: flex;
}

.step4icon {
	flex: 50%;
	padding: 5px;
}

.topDiv > .tagsinputField {
	padding: 10px;
	border: 1px solid var(--input-border);
	border-radius: 3px !important;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	line-height: 18px;
	z-index: 5;
	background: var(--bg-inputfield);
}

.reqd_add_1 .b-form-tags-list .btn {
	margin-right: 25px;
}

.reqd_add_2 .b-form-tags-list .btn {
	margin-right: 0px;
}

.eval-main-table {
	width: 100%;
	position: relative;
	height: calc(100vh - 135px);
	overflow-x: auto;
	overflow-y: hidden;
}

.eval-table-head {
	min-width: 1000px;
	max-width: 100%;
	background-color: #72738e;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 10px 0px;
	color: #fff;
	font-size: 14px;
	font-weight: 500;
}

.eval-table-body {
	min-width: 1000px;
	max-width: 100%;
	overflow-y: auto;
	height: calc(100vh - 240px);
}

.eval-table-row {
	width: 100%;
	position: relative;
	border-radius: 3px;
	border: 0.5px solid #e5e5e5;
	background: #fafafa;
	box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
	display: flex;
	align-items: center;
	font-weight: 400;
	font-size: 13px;
	color: #696969;
	padding: 10px 0px;
	margin: 6px 0px;
}

.eval-table-row:hover {
	background: #e7e8f5;
}

.eval-name-col {
	width: 20%;
}
.eval-email-col {
	width: 20%;
}
.eval-cont-col {
	width: 15%;
}
.eval-exp-col {
	width: 20%;
}
.eval-skill-col {
	width: 20%;
}
.eval-filter-col {
	width: 5%;
}

.paginaTion {
	min-width: 1002px;
	max-width: 100%;
	padding: 5px 10px;
	box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
	border-radius: 0px 0px 5px 5px;
	background: #f2f4fd;
	z-index: 1;
}
</style>
